<template>
  <section class="col-9 position-relative overflow-hidden">
    <MapView v-if="view" :items="items" />
    <ListingView v-else :items="items" />
  </section>
</template>

<script>
import MapView from "@/views/MapView";
import ListingView from "@/views/ListingView.vue";

export default {
  name: 'RightSection',

  props: {
    items: Array,
    view: Boolean
  },

  components: {
    MapView,
    ListingView
  },
}
</script>

<style scoped>
section {
  min-height: var(--height__sections-left-n-right);
  padding: 0;
}

@media (max-width: 1024px) {
  section {
    width: 100%;
    min-height: var(--height__sections-left-n-right-mobile);
  }

  div#listing-container {
    padding-top: 20px;
  }
}
</style>
